// Practice mode (SPEC §12): try anything on a sample warehouse with no account, as an admin or a tech. Nothing is
// saved anywhere real: the phone's copy and the outbox live in their own browser database, which is deleted when
// practice ends. Kept tiny: the database and the sign-in pick their backend from this at start.
export type PracticeAs = "admin" | "tech";
const KEY = "sr2-practice";
export const PRACTICE_DB = "stockroom-v2-practice";

export function practiceAs(): PracticeAs | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === "admin" || v === "tech" ? v : null;
  } catch {
    return null;
  }
}

/** Starts practice as an admin or a tech; the app reloads into the sample warehouse. */
export function enterPractice(as: PracticeAs): void {
  localStorage.setItem(KEY, as);
  location.assign("/");
}

/** Starts over (a fresh sample warehouse) or leaves practice: either way the practice copy and outbox are deleted. */
export async function endPractice(leave: boolean): Promise<void> {
  const [{ default: Dexie }, { getDb }] = await Promise.all([import("dexie"), import("@/data/db")]);
  getDb().close();
  await Dexie.delete(PRACTICE_DB);
  if (leave) localStorage.removeItem(KEY);
  location.assign("/");
}
